import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ConnectedBankOwnerCard from "../../Accounts/OwnerAccounts/ConnectedBankOwnerCard";
import Loader from "../../Loader/Index";

import { useNavigate } from "react-router-dom";
import { ownerListViewAllAcc } from "../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import formatTotalBalance from "../../../utils/formatTotalBalance";
import PrimaryButton from "../CommonButtons/PrimaryButton";
import TickerAnimation from "../TickerAnimation";

const BalanceSummary = ({ type }) => {
  const [ownerAccounts, setOwnerAccounts] = useState([]);

  const [isBalanceSummaryOpen] = useState(true);
  const [connectedBankingTotal, setConnectedBankingTotal] = useState("");

  const [connectedDashboardDataLoading, setConnectedDashboardDataLoading] =
    useState(true);
  const [totalBalanceLoading, setTotalBalanceLoading] = useState(true);
  const [totalCountFav, setTotalCountFav] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [connectedBankingOwnerAccounts, setConnectedBankingOwnerAccounts] =
    useState([]);

  const [totalAccountsCount, setTotalAccountsCount] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { ownerAccBalanceLoading, ownerAccBalanceError } = useSelector(
    (state) => state.ownerAllVerification,
  );
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);
  const services = useSelector((state) => state.refreshToken.services);
  const requiredServices =
    services?.includes("VAccountBalance") || services?.includes("Admin");

  const data = useSelector((state) => state.refreshToken.data);

  const shouldBeRedacted = (price) => {
    return (
      price === "xxxx.xx" ||
      isNaN(+price) ||
      price === null ||
      price === undefined
    );
  };
  useEffect(() => {
    setCurrentPage(1);
    setConnectedBankingOwnerAccounts([]);
  }, [markerData]);

  useEffect(() => {
    const getAllConnectedBankingData = async () => {
      setTotalBalanceLoading(true);
      try {
        const response = await dispatch(
          ownerListViewAllAcc({
            page: 1,
            page_size: 50,
            connected_banking: "Y",
          }),
        );
        setOwnerAccounts(response?.payload?.owner_accounts || []);
        setConnectedBankingTotal(response?.payload?.total_balance || "");
        setTotalAccountsCount(response?.payload?.total_count || 0);
      } catch (error) {
        console.error(error);
      } finally {
        setTotalBalanceLoading(false);
      }
    };

    getAllConnectedBankingData();
  }, [dispatch, markerData]);

  useEffect(() => {
    const getFavoriteConnectedBankingData = async () => {
      setConnectedDashboardDataLoading(true);

      try {
        const response = await dispatch(
          ownerListViewAllAcc({
            page: currentPage,
            page_size: 50,
            favourite: "Y",
          }),
        );

        const newData = response?.payload?.owner_accounts || [];
        setTotalCountFav(response?.payload?.total_count || 0);

        setConnectedBankingOwnerAccounts(newData);
      } catch (error) {
        console.error(error);
      } finally {
        setConnectedDashboardDataLoading(false);
      }
    };

    getFavoriteConnectedBankingData();
  }, [dispatch, currentPage, markerData]);

  return (
    <div
      className={`flex flex-col w-full mt-margin-md   lg:w-balance-summary-width h-balance-summary-height bg-primary-card rounded-border-radius-md overflow-hidden`}
    >
      <div className="flex gap-gap-sm items-center pt-padding-sm px-padding-md   flex-shrink-0">
        <img
          className="w-icon-sm h-icon-sm"
          src={"https://q2pay.in/new_assets/common/settings/entities.svg"}
          alt="entity"
        />
        <p
          title={data?.entity?.entity_name}
          className="text-text-primary text-font-md flex-1 truncate font-semibold"
        >
          <TickerAnimation text={data?.entity?.entity_name} />
        </p>
      </div>

      <div className="pt-padding-sm px-padding-md pb-padding-sm flex flex-col gap-gap-xs flex-shrink-0">
        {totalBalanceLoading ? (
          <div className="flex justify-center items-center py-padding-xs">
            <Loader />
          </div>
        ) : (
          <>
            {requiredServices ? (
              <p className="text-font-xs font-normal text-text-primary">
                <span
                  className={`text-font-sm ${
                    connectedBankingTotal
                      ? connectedBankingTotal <
                        GlobalConfiguration?.lengthCheckZero
                        ? "text-failed font-semibold"
                        : "text-settled font-semibold"
                      : "text-text-primary font-normal"
                  }`}
                >
                  {shouldBeRedacted(connectedBankingTotal) ? "" : "INR "}{" "}
                  {formatTotalBalance(connectedBankingTotal || 0).amount}{" "}
                  {formatTotalBalance(connectedBankingTotal || 0).prefix === ""
                    ? ""
                    : formatTotalBalance(connectedBankingTotal || 0).abbr}
                </span>{" "}
                in{" "}
                <span className="text-font-sm font-semibold text-settled">
                  {totalAccountsCount}
                </span>{" "}
                accounts
              </p>
            ) : (
              <p className="text-font-sm text-settled font-semibold">
                Redacted
              </p>
            )}

            <span className="text-text-primary font-normal text-font-xs">
              Total balance
            </span>
          </>
        )}
      </div>

      <div className="h-[1px] bg-primary-bg flex-shrink-0 mx-margin-md"></div>

      <div className="flex flex-col flex-1 min-h-0 overflow-hidden">
        <div className="flex justify-between items-center px-padding-md py-padding-sm  flex-shrink-0">
          <div className="flex gap-gap-sm items-center">
            <img
              className="w-icon-sm h-icon-sm"
              src={
                "https://q2pay.in/new_assets/common/detail_page/favourite_filled.svg"
              }
              alt="favourite"
            />
            <p className="text-text-primary text-font-md font-normal">
              Favourites
            </p>
          </div>
        </div>

        <div className="flex-1 min-h-0 overflow-y-auto  px-padding-md">
          {connectedDashboardDataLoading ? (
            <div className="flex justify-center items-center h-full">
              <Loader />
            </div>
          ) : connectedBankingOwnerAccounts?.length >
            GlobalConfiguration.lengthCheckZero ? (
            <div className="flex flex-col gap-gap-sm">
              {connectedBankingOwnerAccounts.map((owner, index) => (
                <div className="flex flex-col justify-center">
                  <ConnectedBankOwnerCard
                    key={owner?.id}
                    owner={owner}
                    ownerAccounts={ownerAccounts}
                    setOwnerAccounts={setOwnerAccounts}
                    ownerAccBalanceLoading={ownerAccBalanceLoading}
                    ownerAccBalanceError={ownerAccBalanceError}
                    updateTotalBalance={setConnectedBankingTotal}
                    total_balance={connectedBankingTotal}
                    isBalanceSummaryOpen={isBalanceSummaryOpen}
                    connectedBankingOwnerAccounts={
                      connectedBankingOwnerAccounts
                    }
                    setConnectedBankingOwnerAccounts={
                      setConnectedBankingOwnerAccounts
                    }
                  />
                  {index + GlobalConfiguration.lengthCheckOne ===
                    GlobalConfiguration.ownerAccountConnectedBankingLength && (
                    <p className="pt-padding-sm text-font-xxs text-white text-center ">
                      Showing {connectedBankingOwnerAccounts.length} of{" "}
                      {totalCountFav} accounts
                    </p>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div className="flex justify-center items-center flex-1 h-full">
              <p className="text-text-primary text-center text-font-xs font-normal">
                Favourite owner accounts from their detail page.
                <br />
                Favourited owner accounts will appear here.
              </p>
            </div>
          )}
        </div>
      </div>

      <div className="pt-padding-sm px-padding-md pb-padding-sm flex-shrink-0">
        <PrimaryButton
          btnText="View all favourites "
          btnType="button"
          enabledBgColor="var(--primary-nav-act)"
          isDisabled={
            connectedBankingOwnerAccounts?.length ===
            GlobalConfiguration.lengthCheckZero
          }
          handleFunction={() =>
            navigate("/owner_account_dashboard/owner_accounts_view_all", {
              state: { filter: "Show only favourite" },
            })
          }
          iconToBeAlign="right"
          enabledTextColor={"var(--text-primary)"}
          icon={
            "https://q2pay.in/new_assets/common/arrows/arrow_right_white.svg"
          }
          fullWidthRequired={true}
          isLoaderNeeded={false}
          hoverOption="white"
          imgColor={"var(--text-primary)"}
        />
      </div>
    </div>
  );
};

export default BalanceSummary;
